import { ButtonProps as MuiButtonProps } from '@mui/material';
import React from 'react';

import { StyledButton } from './Button.styled';

interface ButtonProps extends MuiButtonProps {
  children: React.ReactNode;
  btnColor?: string;
  backgroundColor?: string;
}

export const CustomButton: React.FC<ButtonProps> = ({
  children,
  btnColor,
  backgroundColor,
  variant = 'text',
  ...rest
}) => {
  return (
    <StyledButton
      $btnColor={btnColor}
      $backgroundColor={backgroundColor}
      variant={variant}
      {...rest}>
      {children}
    </StyledButton>
  );
};
